import * as React from 'react';
import ExportarPublicaciones from './Components/ExportarPublicaciones';
import ExportarOrdenes from './Components/ExportarOrdenes';
import ExportarNovedades from './Components/ExportarNovedades';
import ExportarLiquidaciones from './Components/ExportarLiquidaciones';
import ExportarSellers from './Components/ExportarSellers';
import { Route } from 'react-router-dom'

export default class AdmPublicaciones extends React.Component {

    render () {
        return (
            <div>
                <Route exact path="/Exportables/Publicaciones" component={ExportarPublicaciones}/>
                <Route exact path="/Exportables/Ordenes" component={ExportarOrdenes}/>
                <Route exact path="/Exportables/Novedades" component={ExportarNovedades}/>
                <Route exact path="/Exportables/Liquidaciones" component={ExportarLiquidaciones}/>
                <Route exact path="/Exportables/Sellers" component={ExportarSellers}/>
            </div>
        ); 
    }
}